/**
 * @file button.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _component = require('./component');

var _component2 = _interopRequireDefault(_component);

var _utilsDomJs = require('./utils/dom.js');

var Dom = _interopRequireWildcard(_utilsDomJs);

var _utilsEventsJs = require('./utils/events.js');

var Events = _interopRequireWildcard(_utilsEventsJs);

var _utilsFnJs = require('./utils/fn.js');

var Fn = _interopRequireWildcard(_utilsFnJs);

var _utilsLogJs = require('./utils/log.js');

var _utilsLogJs2 = _interopRequireDefault(_utilsLogJs);

var _globalDocument = require('global/document');

var _globalDocument2 = _interopRequireDefault(_globalDocument);

var _objectAssign = require('object.assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _tooltip = require('./tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

/**
 * Clickable Component which is clickable or keyboard actionable, but is not a native HTML button
 *
 * @param {Object} player  Main Player
 * @param {Object=} options Object of option names and values
 * @extends Component
 * @class ClickableComponent
 */

var ClickableComponent = (function (_Component) {
  _inherits(ClickableComponent, _Component);

  function ClickableComponent(player, options) {
    _classCallCheck(this, ClickableComponent);

    _Component.call(this, player, options);

    this.appendTooltip();

    this.emitTapEvents();

    this.on('tap', this.handleClick);
    this.on('click', this.handleClick);
    this.on('focus', this.handleFocus);
    this.on('blur', this.handleBlur);
  }

  /**
   * Create the component's DOM element
   *
   * @param {String=} type Element's node type. e.g. 'div'
   * @param {Object=} props An object of properties that should be set on the element
   * @param {Object=} attributes An object of attributes that should be set on the element
   * @return {Element}
   * @method createEl
   */

  ClickableComponent.prototype.createEl = function createEl() {
    var tag = arguments.length <= 0 || arguments[0] === undefined ? 'div' : arguments[0];
    var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    var attributes = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

    props = _objectAssign2['default']({
      className: this.buildCSSClass(),
      tabIndex: 0
    }, props);

    if (tag === 'button') {
      _utilsLogJs2['default'].error('Creating a ClickableComponent with an HTML element of ' + tag + ' is not supported; use a Button instead.');
    }

    // Add ARIA attributes for clickable element which is not a native HTML button
    attributes = _objectAssign2['default']({
      role: 'button',
      'aria-live': 'polite' // let the screen reader user know that the text of the element may change
    }, attributes);

    var el = _Component.prototype.createEl.call(this, tag, props, attributes);

    this.createControlTextEl(el);

    return el;
  };

  /**
   * create control text
   *
   * @param {Element} el Parent element for the control text
   * @return {Element}
   * @method controlText
   */

  ClickableComponent.prototype.createControlTextEl = function createControlTextEl(el) {
    this.controlTextEl_ = Dom.createEl('span', {
      className: 'vjs-control-text'
    });

    if (el) {
      el.appendChild(this.controlTextEl_);
    }

    this.controlText(this.controlText_);

    return this.controlTextEl_;
  };

  /**
   * Controls text - both request and localize
   *
   * @param {String} text Text for element
   * @return {String}
   * @method controlText
   */

  ClickableComponent.prototype.controlText = function controlText(text) {
    if (!text) return this.controlText_ || 'Need Text';

    this.controlText_ = text;
    this.controlTextEl_.innerHTML = this.localize(this.controlText_);

    if (this.tooltip) {
      this.tooltip.text(this.controlText_);
    } else {
      this.appendTooltip();
    }

    return this;
  };

  /**
   * Allows sub components to stack CSS class names
   *
   * @return {String}
   * @method buildCSSClass
   */

  ClickableComponent.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-control vjs-button ' + _Component.prototype.buildCSSClass.call(this);
  };

  /**
   * Adds a child component inside this clickable-component
   *
   * @param {String|Component} child The class name or instance of a child to add
   * @param {Object=} options Options, including options to be passed to children of the child.
   * @return {Component} The child component (created by this process if a string was used)
   * @method addChild
   */

  ClickableComponent.prototype.addChild = function addChild(child) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    // TODO: Fix adding an actionable child to a ClickableComponent; currently
    // it will cause issues with assistive technology (e.g. screen readers)
    // which support ARIA, since an element with role="button" cannot have
    // actionable child elements.

    //let className = this.constructor.name;
    //log.warn(`Adding a child to a ClickableComponent (${className}) can cause issues with assistive technology which supports ARIA, since an element with role="button" cannot have actionable child elements.`);

    return _Component.prototype.addChild.call(this, child, options);
  };

  /**
   * Enable the component element
   *
   * @return {Component}
   * @method enable
   */

  ClickableComponent.prototype.enable = function enable() {
    this.removeClass('vjs-disabled');
    this.el_.setAttribute('aria-disabled', 'false');
    return this;
  };

  /**
   * Disable the component element
   *
   * @return {Component}
   * @method disable
   */

  ClickableComponent.prototype.disable = function disable() {
    this.addClass('vjs-disabled');
    this.el_.setAttribute('aria-disabled', 'true');
    return this;
  };

  /**
   * Handle Click - Override with specific functionality for component
   *
   * @method handleClick
   */

  ClickableComponent.prototype.handleClick = function handleClick() {};

  /**
   * Handle Focus - Add keyboard functionality to element
   *
   * @method handleFocus
   */

  ClickableComponent.prototype.handleFocus = function handleFocus() {
    Events.on(_globalDocument2['default'], 'keydown', Fn.bind(this, this.handleKeyPress));
  };

  /**
   * Handle KeyPress (document level) - Trigger click when Space or Enter key is pressed
   *
   * @method handleKeyPress
   */

  ClickableComponent.prototype.handleKeyPress = function handleKeyPress(event) {
    // Support Space (32) or Enter (13) key operation to fire a click event
    if (event.which === 32 || event.which === 13) {
      event.preventDefault();
      this.handleClick(event);
    } else if (_Component.prototype.handleKeyPress) {
      _Component.prototype.handleKeyPress.call(this, event); // Pass keypress handling up for unsupported keys
    }
  };

  /**
   * Handle Blur - Remove keyboard triggers
   *
   * @method handleBlur
   */

  ClickableComponent.prototype.handleBlur = function handleBlur() {
    Events.off(_globalDocument2['default'], 'keydown', Fn.bind(this, this.handleKeyPress));
  };

  /**
   * Append a tooltip to the component
   *
   * @method appendTooltip
   */

  ClickableComponent.prototype.appendTooltip = function appendTooltip() {
    if (this.tooltip || !this.controlText_ || !this.el()) {
      return;
    }

    var tooltipHandler = this.tooltipHandler();

    if (tooltipHandler) {
      this.tooltip = new _tooltip2['default'](this.player_);
      this.el().appendChild(this.tooltip.el());
      this.tooltip.text(this.controlText_);
      this.tooltip.handler(tooltipHandler);
    }
  };

  /**
   * Return handler for the tooltip
   *
   * @return {Object} Dom element to serve as a handler for the tooltip
   * @method tooltipHandler
   */

  ClickableComponent.prototype.tooltipHandler = function tooltipHandler() {
    var handler = this.options_.tooltip;

    if (handler === false) {
      return;
    }

    if (handler === true || this.player_.options_ && this.player_.options_.tooltips) {
      return this.el();
    }

    if (typeof handler === 'string') {
      return Dom.getEl(handler);
    }

    if (handler && typeof handler.el === 'function') {
      return handler.el();
    }

    return handler;
  };

  return ClickableComponent;
})(_component2['default']);

_component2['default'].registerComponent('ClickableComponent', ClickableComponent);
exports['default'] = ClickableComponent;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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